'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import UserIcon from 'public/icons/user-icon.svg';
import styles from './Usernav.module.scss';
import { getCookie } from 'cookies-next';
import classNames from 'classnames';
import { useEnvContext } from '@/context/envContext';
import { useTranslations } from 'next-intl';
const UserNav = () => {
  const t = useTranslations('Header');
  const pathname = usePathname();
  const {
    webUrl,
    userUrl
  } = useEnvContext();
  const navUrl = webUrl ? webUrl : 'https://www.techtarget.com';
  const accUrl = userUrl ? userUrl : 'https://users.techtarget.com';
  const fromUrl = encodeURIComponent(navUrl + '/hub' + pathname);
  const crs = getCookie('crs');
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Only load if you are on client
  if (!isClient) {
    return;
  }

  // If we can see crs/fastpass/uidLoggedIn token, then show logout
  if (crs) {
    return <>
    <div className="comp-brand">
     <a href={`${accUrl}/registration/contenthub/EditProfile.page?fromURL=${fromUrl}`} rel={'nofollow'}>
      <Image src={UserIcon} className={styles['icon-center-text']} alt="User Avatar" />
     </a>
     <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${userUrl}/registration/v2/api/logout?fromURL=${fromUrl}`}>
      {t('LogoutLink')}
     </a>
    </div>
   </>;
  } else {
    // Show Login if we can't find crs/fastpass/uidLoggedIn token
    return <>
    <div className="comp-brand">
     <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${navUrl}/login?fromURL=${fromUrl}`}>
      {t('LoginLink')}
     </a>
     {pathname.includes('asset') ? '' : <>
       <span className={styles['divider-line']} aria-hidden={'true'}>
        {' '}
        |{' '}
       </span>
       <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${navUrl}/register?fromURL=${fromUrl}`}>
        {t('RegisterLink')}
       </a>
      </>}
    </div>
   </>;
  }
};
export default UserNav;